import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import { AuthHttp } from 'angular2-jwt';

import { UserModel } from './../../models';

@Injectable()
export class UserService {
    constructor(private http: AuthHttp) {

    }

    getById(id: string): Observable<UserModel> {
        return this.http.get('api/user/'+id).map((r: Response) => r.json());
    }

    getUser(): Observable<UserModel[]> {
        return this.http.get('api/user').map((r: Response) => r.json());
    }
    
    create(user: UserModel) {
        return this.http.post('api/user', JSON.stringify(user), { headers: new Headers({ 'Content-Type': 'application/json' }) });
    }

    update(id: string, user: UserModel) {
        return this.http.put('api/user/'+id, JSON.stringify(user), { headers: new Headers({ 'Content-Type': 'application/json' }) });
    }

    delete(id: string) {
        return this.http.delete('api/user/'+id);
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/services/user-service/user.service.ts